import { Link } from "react-router-dom";
import '../css/nftGenerator16.css';
import { properties } from '../properties.js';
import QRCode from "react-qr-code";
import React, { useState, useEffect } from 'react';



const CertificateDisplay = ({ item, index, account, mapping, certificadoId, certificadoName}) => {
  
    
  const [imageUri, setImageUri] = useState(''); // Estado para almacenar la URL de la imagen

  
 
  if(typeof(mail) == properties.noMailValue){
    const QRCodeString = `${properties.clientApp}/${mapping}/DPP/QRDPP?idLinea=${encodeURIComponent(item.idLinea)}&certificadoId=${certificadoId}`
      return (
        <div className="card_item_16" key={item.id}>
  
          <Link className="models_16" to={`/${mapping}/DPP/DPPDisplay?idLinea=${encodeURIComponent(item.idLinea)}&certificadoId=${certificadoId}&certificadoName=${certificadoName}`} state={item}>
  
            <QRCode value={QRCodeString} />
            <p className="card_model_16"> {item.idLinea} </p>
  
          </Link>
        </div>
      );
  
    }
  }
  
  export default CertificateDisplay;